const content = {
  textOffer: 'Oferta por tiempo limitado'
}

export default content
